import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import LayoutWithOutAccountCard from '../../../layout/Layout/layout-without-card'
import { MENU_OPTIONS } from '../../../layout/Layout/menu-options'
import MenuCard from '../../../layout/Navigation/menu-card'
import { getMenuListSelector } from '../../../selectors'

const menuDetails =  MENU_OPTIONS.filter(e => e.key === "OTHER_SERVICES")[0].children

export default function AdditionalLinks() {
  const history = useHistory()
  const menuConfig = useSelector(getMenuListSelector)['OTHER_SERVICES'] || {}
  return (
    <LayoutWithOutAccountCard
      breadCumKey='ADDITIONAL_LINKS'
      keyPath={'SUPPORT_CENTER'}
      showEmptySpace={true}>
      <Row>
        {Object.keys(menuConfig).length>0 && menuDetails.map((option, index) => (
          <>
            {menuConfig[option.key] &&
              <MenuCard
                handleMenuCallback={() => history.push(option.link)}
                icon={option.icon}
                name={option.title}
                description={option.desc}
                key={index}
              />
            }
          </>
        ))}
      </Row>
    </LayoutWithOutAccountCard>
  )
}
